<label
    class="select-none"
    [ngClass]="wrap() ? '!flex-row items-center w-full !gap-3' : 'flex-col'"
>
    @if (labelPosition() === "out") {
        @if (label(); as label) {
            <app-label [required]="required()">
                {{ label }}
            </app-label>
        }
    }
    @if (hint() && hint().length > 0) {
        <div class="flex flex-col gap-2">
            @for (hint of hint(); track $index) {
                <app-hint>{{ hint }}</app-hint>
            }
        </div>
    }

    <div
        [attr.data-size]="currentSize()"
        [attr.data-rounded]="currentRounded()"
        [attr.data-disabled]="disabled()"
        class="relative input-wrapper input-rounded input-padding w-full"
    >
        <div
            [attr.data-color]="currentColor()"
            [attr.data-rounded]="currentRounded()"
            class="input-outline input-rounded"
        ></div>
        <div class="flex flex-col w-full">
            @if (labelPosition() === "in") {
                <app-label [required]="required()">{{ label() }}</app-label>
            }
            <div class="flex items-center">
                <ng-container *ngTemplateOutlet="prefixIconSection" />
                <ng-container *ngTemplateOutlet="prefixSection" />
                <input
                    required
                    #inputRef
                    (click)="inputClick.emit()"
                    (focus)="inputFocus.emit()"
                    (blur)="inputBlur.emit()"
                    (keydown)="inputKeydown.emit($event)"
                    (change)="handleChange()"
                    class="w-full input-text-size peer min-h-6"
                    [attr.data-size]="currentSize()"
                    [type]="type()"
                    [attr.list]="list()"
                    [placeholder]="_placeholder() || ''"
                    [spellcheck]="spellcheck()"
                    [autocomplete]="autocomplete()"
                    [autofocus]="autofocus()"
                    [readOnly]="readonly()"
                    [disabled]="disabled()"
                    [maxLength]="maxlength() || 524288"
                    [value]="value() || inputValue() || ''"
                    [inputMode]="inputMode()"
                    [required]="required()"
                    [inputNumber]="inputNumber() ? 'true' : 'false'"
                    [inputNumberMax]="max()!"
                    [max]="currentMax()"
                />
                <div (click)="suffixClick.emit()" class="flex items-center">
                    <ng-container *ngTemplateOutlet="suffixIconSection" />
                    <ng-container *ngTemplateOutlet="suffixSection" />
                </div>
            </div>
        </div>
    </div>
</label>

<ng-template #prefixIconSection>
    @if (prefixIcon(); as icon) {
        <div class="flex items-center mr-2">
            <app-icon [name]="icon" class="text-gray-400" size="sm" />
        </div>
    }
</ng-template>

<ng-template #suffixIconSection>
    @if (icon() || suffixIcon()) {
        <app-icon
            [name]="icon() || suffixIcon() || ''"
            class="!size-5 min-w-5"
        />
    } @else {
        <ng-content name="[icons]" />
    }
</ng-template>

<ng-template #suffixSection>
    @if (suffix()) {
        <p class="text-sm text-gray-500 min-w-max">
            {{ suffix() }}
        </p>
    }
</ng-template>

<ng-template #prefixSection>
    @if (prefix()) {
        <p class="text-sm text-gray-500 min-w-max mr-2">
            {{ prefix() }}
        </p>
    }
</ng-template>
